"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeBackgroundShorthand = exports.openBackgroundShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var tokenizers_1 = require("../../tokenizers");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
// background
var openBackgroundShorthand = function () {
    var bgLayerShorthandParts = [
        { prop: 'background-image', dataType: css_data_types_1.imageSourceDataType },
        { prop: 'background-position', dataType: css_data_types_1.bgPositionDataType, multipleItems: true },
        { prop: 'background-size', dataType: css_data_types_1.bgSizeDataType, multipleItems: true },
        { prop: 'background-repeat', dataType: css_data_types_1.repeatStyleDataType, multipleItems: true },
        { prop: 'background-attachment', dataType: css_data_types_1.attachmentDataType },
        {
            prop: 'background-origin',
            dataType: css_data_types_1.backgroundOriginDataType,
            partOpener: (0, shorthand_parser_utils_1.splitSimpleShorthandOpener)(['background-origin', 'background-clip']),
        },
        { prop: 'background-clip', dataType: css_data_types_1.backgroundClipDataType },
    ];
    var lastBgLayerShorthandParts = [
        {
            prop: 'background-color',
            dataType: css_data_types_1.backgroundColorDataType,
        },
    ].concat(bgLayerShorthandParts);
    var openBackgroundShorthandLayerInner = (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(bgLayerShorthandParts);
    var openBackgroundShorthandLastLayerInner = (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(lastBgLayerShorthandParts);
    var backgroundShorthandOpener = (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'background',
        parts: lastBgLayerShorthandParts,
        shorthandOpener: function (astNodes, api) {
            return (0, shorthand_parser_utils_1.layersShorthandOpener)('background', openBackgroundShorthandLayerInner, bgLayerShorthandParts, openBackgroundShorthandLastLayerInner, lastBgLayerShorthandParts)(astNodes, api);
        },
    });
    var multipleItemProps = bgLayerShorthandParts
        .filter(function (part) { return part.multipleItems; })
        .map(function (part) { return part.prop; });
    return function (shortHand, api) {
        var e_1, _a;
        var openedShorthand = backgroundShorthandOpener(shortHand, api);
        var layers = [];
        var currLayer;
        for (var i = 0; (currLayer = (0, shorthand_parser_utils_1.getOpenedLayer)(openedShorthand, i, multipleItemProps)) !== undefined; i++) {
            layers.push(currLayer);
        }
        var color = layers[0]['background-color'];
        try {
            for (var layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                var layer = layers_1_1.value;
                delete layer['background-color'];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return {
            layers: layers,
            color: color,
        };
    };
};
exports.openBackgroundShorthand = openBackgroundShorthand;
var closeBackgroundShorthand = function () {
    return function (opened, api, detachExpression) {
        var backgroundLayerCloser = (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", " / ", " ", " ", " ", " ", ""], ["", " ", " / ", " ", " ", " ", " ", ""])), 'background-image', 'background-position', 'background-size', 'background-repeat', 'background-attachment', 'background-origin', 'background-clip'));
        var nonColorLayers = [];
        opened.layers.forEach(function (layer) {
            nonColorLayers = nonColorLayers.concat(backgroundLayerCloser(layer, api, detachExpression));
            nonColorLayers.push(tslib_1.__assign(tslib_1.__assign({}, (0, tokenizers_1.valueTextNode)(',')), { type: ',' }));
        });
        nonColorLayers.pop();
        return (0, shorthand_parser_utils_1.fixAstNodesPositions)(nonColorLayers.concat((0, shorthand_parser_utils_1.getOpenedNode)(opened.color, api, detachExpression)), api);
    };
};
exports.closeBackgroundShorthand = closeBackgroundShorthand;
var templateObject_1;
//# sourceMappingURL=background-shorthand.js.map